import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import StudentsManager from "@/components/StudentsManager";
import { School } from "lucide-react";

export default function AdminStudents() {
  const [schools, setSchools] = useState([]);
  const [schoolId, setSchoolId] = useState("");

  useEffect(() => {
    api.get("/schools").then((r) => {
      setSchools(r.data);
      if (r.data.length) setSchoolId(r.data[0].id);
    });
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-extrabold text-slate-800">بيانات الطلاب</h1>
        <p className="text-slate-400">اختر مدرسة لإدارة طلابها ورفع قاعدة بياناتها</p>
      </div>

      <Card>
        <CardContent className="p-4">
          <Label className="mb-1 block text-xs text-slate-500">المدرسة</Label>
          <div className="max-w-sm">
            <Select value={schoolId} onValueChange={setSchoolId}>
              <SelectTrigger data-testid="admin-select-school">
                <SelectValue placeholder="اختر المدرسة" />
              </SelectTrigger>
              <SelectContent>
                {schools.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </CardContent>
      </Card>

      {schoolId ? (
        <StudentsManager schoolId={schoolId} schoolName={schools.find((s) => s.id === schoolId)?.name} key={schoolId} />
      ) : (
        <div className="flex flex-col items-center gap-2 py-16 text-slate-400">
          <School className="h-10 w-10" />
          <p>يرجى إضافة مدرسة أولاً</p>
        </div>
      )}
    </div>
  );
}
